import { CommonModule, NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Message, MessageCategory } from '../../../../../util/src/index';

export type SenderType = 'patient' | 'system' | 'doctor';

export interface WidgetInstance {
  component: import('@angular/core').Type<unknown>;
  inputs: { data: Record<string, unknown> };
}

@Component({
  selector: 'messaging-message-bubble',
  standalone: true,
  imports: [CommonModule, NgComponentOutlet],
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageBubbleComponent {
  message = input.required<Message>();
  contentHtml = input.required<SafeHtml>();
  widgets = input<WidgetInstance[]>([]);
  patientId = input.required<number>();
  senderType = input.required<SenderType>();
  showActions = input(false);
  categories = input<MessageCategory[]>([]);

  @Output() categoryChange = new EventEmitter<{ messageId: number; categoryId: number }>();
  @Output() readToggle = new EventEmitter<{ messageId: number; readAt: string | null }>();

  protected get isIncoming(): boolean {
    return this.message().incoming;
  }

  protected get isUnread(): boolean {
    return !this.message().read && this.message().from.id === this.patientId();
  }

  protected get isSms(): boolean {
    return this.message().entry_type === 'sms';
  }

  protected get senderName(): string {
    const from = this.message().from;
    if (from.id === -1) return 'Boots Online Doctor';
    if (from.firstname) return `${from.firstname} ${from.lastname}`;
    return 'Unknown';
  }

  protected get sentDate(): string {
    return this.message().sent;
  }

  protected get readDate(): string | null {
    return this.message().read;
  }

  protected get isOutgoing(): boolean {
    return this.message().from.id !== this.patientId();
  }

  protected onCategoryChange(event: Event) {
    const value = +(event.target as HTMLSelectElement).value;
    if (value) this.categoryChange.emit({ messageId: this.message().id, categoryId: value });
  }

  protected onReadToggle() {
    this.readToggle.emit({ messageId: this.message().id, readAt: this.message().read });
  }
}
